/* ---------------------------------------------------------------------------
   UF PROBLEM — symptom chip info panels.

   Mirrors the feature pills on the buy box: click to open, one at a time,
   dismissed by Escape or a click outside. Hover is handled entirely in CSS and
   is an addition rather than the mechanism — a hover-only reveal does not
   exist on a phone, and this section gets read on phones more than anywhere.

   The only thing JS does beyond the toggle is decide which side each panel
   hangs from. Chips wrap, so one near the right edge would push a 280px panel
   off the screen; those get flipped to anchor from the right instead.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  if (window.__ufProblemBound) return;
  window.__ufProblemBound = true;

  var OPEN = 'data-open';

  function closeAll(except) {
    Array.prototype.slice
      .call(document.querySelectorAll('.uf-problem__item[' + OPEN + '="true"]'))
      .forEach(function (item) {
        if (item === except) return;
        item.setAttribute(OPEN, 'false');
        var btn = item.querySelector('[data-uf-problem-chip]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
  }

  document.addEventListener('click', function (event) {
    var btn =
      event.target.closest && event.target.closest('[data-uf-problem-chip]');

    if (!btn) {
      closeAll(null);
      return;
    }

    var item = btn.closest('.uf-problem__item');
    if (!item) return;

    var isOpen = item.getAttribute(OPEN) === 'true';
    closeAll(item);
    item.setAttribute(OPEN, String(!isOpen));
    btn.setAttribute('aria-expanded', String(!isOpen));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });

  /**
   * Keep every panel inside its container.
   *
   * The panel is wider than most chips, so one anchored to a chip near either
   * edge would hang outside — and because the panel is absolutely positioned,
   * hanging outside adds scrollable width to the whole PAGE even while it is
   * invisible. That is a sideways-scrolling product page caused by a tooltip
   * nobody has opened yet, which is why this runs on load rather than on open.
   *
   * Clamping to an explicit offset rather than flipping left/right: a flip
   * fixes the right edge and can then break the left one on a narrow screen,
   * and there is no third state to fall back to. Clamping has no such gap.
   *
   * The container is the CARD when there is one, not the section — the card's
   * padding is the real boundary, and measuring to the section lets a panel
   * spill across the card's edge onto the background.
   */
  function alignPanels() {
    Array.prototype.slice
      .call(document.querySelectorAll('.uf-problem__item'))
      .forEach(function (item) {
        var panel = item.querySelector('[data-uf-problem-info]');
        if (!panel) return;

        var box =
          item.closest('.uf-problem__card') || item.closest('.uf-problem');
        if (!box) return;

        var boxStyle = window.getComputedStyle(box);
        var boxRect = box.getBoundingClientRect();
        var left = boxRect.left + parseFloat(boxStyle.paddingLeft || 0);
        var right = boxRect.right - parseFloat(boxStyle.paddingRight || 0);
        var available = right - left;

        /* Reset before measuring, or each pass compounds the last one's
           offset and the panel walks across the screen on every resize. */
        panel.style.left = '';
        panel.style.right = 'auto';
        panel.style.maxWidth = '';

        if (available > 0) {
          panel.style.maxWidth = Math.min(280, available) + 'px';
        }

        var itemLeft = item.getBoundingClientRect().left;
        var width = panel.offsetWidth;
        var target = itemLeft;

        if (target + width > right) target = right - width;
        if (target < left) target = left;

        panel.style.left = Math.round(target - itemLeft) + 'px';
      });
  }

  function init() {
    alignPanels();

    var pending;
    function schedule() {
      window.clearTimeout(pending);
      pending = window.setTimeout(alignPanels, 120);
    }

    window.addEventListener('resize', schedule);

    /* A ResizeObserver on the section catches layout changes a window resize
       event misses — the card reflowing, an image finally loading, the theme
       editor swapping settings underneath us. */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      Array.prototype.slice
        .call(document.querySelectorAll('.uf-problem'))
        .forEach(function (section) {
          ro.observe(section);
        });
    }

    /* Fonts landing late change chip widths, and therefore where the panels
       need to sit. Cheap to redo once everything has settled. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(alignPanels);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', alignPanels);
})();
